import { useBuscarInventarioPromedioGrafico } from "../../Scripts/Service/inventario-service.js";

import { SelectButton, Message } from 'primereact';
import React from "react";

export const GraficosInventario = () => {
  const defaultLoadingChart = {
    text:'cargando'
  }
  const color = ["#3fb1e3", "#91cc75", "#fac858", "#ee6666"];
  const moneda = window.monedaPredeterminada;
  const labelOptions = {
    show: true,
    rotate: 90,
    align: "left",
    position: "insideBottom",
    verticalAlign: "middle",
    color: "#000",
    fontSize: 12,
  };
  const [where, setWhere] = React.useState({ where: { periodo: "mensual" } });
  const [value, setValue] = React.useState(3);
  const periodos = [
    { name: "Diario", value: 1 },
    { name: "Semanal", value: 2 },
    { name: "Mensual", value: 3 },
    { name: "Trimestral", value: 4 },
    { name: "Anual", value: 5 },
  ];
  const { data: GraficosData } =
    useBuscarInventarioPromedioGrafico(where);

  function m(n, d) {
    //Convertir numero => 3,000,000 a 3M
    const x = Math.floor(Math.log10(Math.abs(n)));
    const suffix = ["", "k", "M", "MM", "T", "P", "E"];
    const magnitude = Math.floor(x / 3);
    const scaled = n / Math.pow(10, magnitude * 3);
    const rounded = Math.round(scaled * Math.pow(10, d)) / Math.pow(10, d);

    return rounded + " " + suffix[magnitude];
  }
  function handleChange(value) {
    setValue(value);
    let periodo;
    GraficosData.Resultados.map(e => cargandoGrafico(e))

    switch (value) {
      case 1:
        periodo = "diario";
        break;
      case 2:
        periodo = "semanal";
        break;
      case 3:
        periodo = "mensual";
        break;
      case 4:
        periodo = "trimestral";
        break;
      case 5:
        periodo = "anual";
        break;
    }
    setWhere({ where: { periodo: periodo } });
  }
  function crearDivGrafico(data) {
    let chartTitulo = data[0].Desc;
    let dom = document.getElementById("chart_" + chartTitulo);
    if (dom) {
      var chartTemp = echarts.getInstanceByDom(
        document.getElementById("chart_" + chartTitulo)
      );
      if (chartTemp) {
        chartTemp.dispose();
      }
    } else {
      let chart = document.createElement("div");
      chart.setAttribute("id", "chart_" + chartTitulo);
      chart.setAttribute("class", "chart");
      document.getElementById("chart_holder").appendChild(chart);
    }
  }
  function crearGrafico(data) {
    let chartTitulo = data[0].Desc;

    crearDivGrafico(data);
    var chartDom = document.getElementById("chart_" + chartTitulo);
    const chart = echarts.init(chartDom, null, { width: "653", height: "300" });
    chart.showLoading();
    var options = {
      color: color,
      title: {
        text: chartTitulo,
        left: "center",
        textStyle: {
          fontStyle: "normal",
          fontWeight: "bolder",
          fontFamily: "sans-serif",
        },
      },
      legend: {
        orient: "horizontal",
        left: "center",
        top: "bottom",
        show: false
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
      },
      dataset: {
        dimensions: ["periodo", "Total"],
        source: data.map((d) => {
          return {
            periodo: d.FechaDesc,
            Total: d.Promedio,
          };
        }),
      },
      xAxis: { type: "category" },
      yAxis: {
        type: "value",
        axisLabel: {
          fontSize: 9,
          formatter: function (params) {
            if (params >= 1000) return `${moneda} ${m(params, 1)}`;
            else
              return `${moneda} ${Citrus.Convert.toCurrencyNoSimbolo(params)}`;
          },
        },
      },
      // Declare several bar series, each will be mapped
      // to a column of dataset.source by default.
      series: [
        {
          type: "bar",
          emphasis: {
            focus: "series",
          },
          label: {
            ...labelOptions,
            formatter: function (params) {
              return (
                moneda +
                " " +
                Citrus.Convert.toCurrencyNoSimbolo(params.value.Total)
              );
            },
          },
          tooltip: {
            valueFormatter: (value) =>
              moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(value),
          },
        },
      ],
    };
    chart.setOption(options);
    chart.hideLoading();
  }
  function crearGraficoTasas(data) {
    let chartTitulo = data[0].Desc;

    crearDivGrafico(data);
    var chartDom = document.getElementById("chart_" + chartTitulo);
    const chart = echarts.init(chartDom, null, { width: "653", height: "300" });
    var options = {
      color: color,
      title: {
        text: chartTitulo,
        left: "center",
        textStyle: {
          fontStyle: "normal",
          fontWeight: "bolder",
          fontFamily: "sans-serif",
        },
      },
      legend: {
        orient: "horizontal",
        left: "center",
        top: "bottom",
        show: false
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
      },
      dataset: {
        dimensions: ["periodo", "Total"],
        source: data.map((d) => {
          return {
            periodo: d.FechaDesc,
            Total: d.Promedio,
          };
        }),
      },
      xAxis: { type: "category" },
      yAxis: {
        type: "value",
        axisLabel: {
          fontSize: 9,
          formatter: function (params) {
            return `${params} %`
          },
        },
      },
      // Declare several bar series, each will be mapped
      // to a column of dataset.source by default.
      series: [
        {
          type: "bar",
          emphasis: {
            focus: "series",
          },
          label: {
            ...labelOptions,
            formatter: function (params) {
              return params.value.Total.toFixed(2) + " %";
            },
          },
          tooltip: {
            valueFormatter: (value) => (value).toFixed(2) + " %",
          },
        },
      ],
    };
    chart.setOption(options);
  }
  function crearGraficoCantidades(data) {
    crearDivGrafico(data);
    let chartTitulo = data[0].Desc;
    var chartDom = document.getElementById("chart_" + chartTitulo);
    const chart = echarts.init(chartDom, null, { width: "653", height: "300" });
    var options = {
      color: color,
      title: {
        text: chartTitulo,
        left: "center",
        textStyle: {
          fontStyle: "normal",
          fontWeight: "bolder",
          fontFamily: "sans-serif",
        },
      },
      legend: {
        orient: "horizontal",
        left: "center",
        top: "bottom",
        show: false
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
      },
      dataset: {
        dimensions: ["periodo", "Total"],
        source: data.map((d) => {
          return {
            periodo: d.FechaDesc,
            Total: d.Promedio,
          };
        }),
      },
      xAxis: { type: "category" },
      yAxis: {
        type: "value",
        axisLabel: {
          fontSize: 9,
        },
      },
      // Declare several bar series, each will be mapped
      // to a column of dataset.source by default.
      series: [
        {
          type: "bar",
          emphasis: {
            focus: "series",
          },
          label: {
            ...labelOptions,
            formatter: function (params) {
              return params.value.Total.toFixed(2);
            },
          },
          tooltip: {
            valueFormatter: (value) => value.toFixed(2),
          },
        },
      ],
    };
    chart.setOption(options);
  }
  function cargandoGrafico(data) {
    let chartTitulo = data[0].Desc
    var chartTemp = echarts.getInstanceByDom(
      document.getElementById("chart_" + chartTitulo)
    );
    chartTemp.showLoading(defaultLoadingChart)
  }
  React.useEffect(() => {
    if (GraficosData) {
        GraficosData.Resultados.map((e) => {
        let chartTitulo = e[0].Desc;
        if(chartTitulo.includes("Tasa") || chartTitulo.includes("Servicio")){
            crearGraficoTasas(e);
        }else if (chartTitulo.includes("Promedio")) {
            crearGrafico(e)
        }else {
            crearGraficoCantidades(e);
        }
    })
    }
  }, [GraficosData]);
  return (
    <div>
      <SelectButton
        value={value}
        onChange={(e) => handleChange(e.value)}
        optionLabel="name"
        options={periodos}
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "10px",
          padding: "12px",
          flexFlow: "columnWrap",
          aligItems: "center",
        }}
      />
      <div id="chart_holder" class="card_row"></div>
    </div>
  );
};
